import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable, finalize, shareReplay } from 'rxjs';

const inFlightRequests = new Map<string, Observable<HttpEvent<unknown>>>();

function getRequestKey(method: string, urlWithParams: string): string {
  return `${method.toUpperCase()}::${urlWithParams}`;
}

export const requestDedupInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method.toUpperCase() !== 'GET' || req.headers.get('X-Skip-Request-Dedup') === 'true') {
    return next(req);
  }

  const key = getRequestKey(req.method, req.urlWithParams);
  const ongoingRequest = inFlightRequests.get(key);
  if (ongoingRequest) {
    return ongoingRequest;
  }

  const sharedRequest = next(req).pipe(
    finalize(() => {
      inFlightRequests.delete(key);
    }),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  inFlightRequests.set(key, sharedRequest);
  return sharedRequest;
};
